import React from 'react';
import { PortfolioBlog } from '../api/API';
import { useTranslate } from '../services/translation';
import { useLanguage } from '../LanguageContext';
import { Link } from 'react-router-dom';
import '../assets/css/BlogCard.css';

interface BlogCardProps {
  blog: PortfolioBlog;
}

const BlogCard: React.FC<BlogCardProps> = ({ blog }) => {
  const { translate } = useTranslate();
  const { language } = useLanguage();

  return (
    <Link to={`/${language}/blog/${blog.slug}`} className="blog-card-link">
      <div className="blog-card">
        <div className="blog-header">
          <h3 className="blog-title white">{translate(blog.title as any)}</h3>
        </div>

        <div className="blog-content">
          <p className="blog-description light">{translate(blog.description as any)}</p>
        </div>

        <div className="blog-footer">
          <span className="blog-read-more">
            {translate('common.read_more')} →
          </span>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
